import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { t } from 'i18next';
import { useContext } from 'react';

import { Skeleton } from '~components/Skeleton/Skeleton';
import { Job } from '~hooks/useJob/models';
import CategoryColumn from '~pages/Approvals/Files/components/AllFilesTable/Columns/CategoryColumn';
import FileColumn from '~pages/Approvals/Files/components/AllFilesTable/Columns/FileColumn';
import UploadDateColumn from '~pages/Approvals/Files/components/AllFilesTable/Columns/UploadDateColumn';
import AllFilesQueryContext, {
  AllFilesQueryContextProvider,
} from '~pages/Approvals/Files/components/JobsTable/ExpandedBlock/AllFilesQueryContext';

import { chargesRaisedCardSx } from '../chargesGrid';

const FILE_THUMBNAIL_SIZE_IN_PX = 24;
const FILE_ROW_COLUMNS = 'minmax(0, 2fr) minmax(0, 1fr) minmax(0, 1fr)';

interface ChargesJobFilesProps {
  job: Job;
}

export default function ChargesJobFiles({ job }: ChargesJobFilesProps) {
  return (
    <AllFilesQueryContextProvider job={job}>
      <JobFilesCard />
    </AllFilesQueryContextProvider>
  );
}

function JobFilesCard() {
  const { data: files, isFetching } = useContext(AllFilesQueryContext);
  const hasNoFilesToShow = !isFetching && !files?.length;

  if (hasNoFilesToShow) {
    return null;
  }

  return (
    <Box data-test-id="charges-job-files" sx={chargesRaisedCardSx}>
      <Typography sx={{ fontSize: '14px', fontWeight: 600, px: 1.5, pt: 1.5 }}>
        {files ? (
          t('approvals.approve_charges.job_files', { count: files.length })
        ) : (
          <Skeleton variant="text" width={80} />
        )}
      </Typography>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, p: 1.5 }}>
        {files ? (
          files.map((file) => (
            <Box
              key={file.id}
              sx={{
                alignItems: 'center',
                display: 'grid',
                gap: 1,
                gridTemplateColumns: FILE_ROW_COLUMNS,
              }}
            >
              <FileColumn file={file} imageSizeInPx={FILE_THUMBNAIL_SIZE_IN_PX} />
              <CategoryColumn file={file} />
              <UploadDateColumn file={file} />
            </Box>
          ))
        ) : (
          <Skeleton height={20} variant="text" />
        )}
      </Box>
    </Box>
  );
}
